import { motion } from "framer-motion";

const CLIENTS = [
  {
    img: "https://images.pexels.com/photos/281502/pexels-photo-281502.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Brokerages",
    sub: "Real estate agencies",
  },
  {
    img: "https://images.unsplash.com/photo-1788129115413-94ef53500f89?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjB2aWxsYSUyMGludGVyaW9yJTIwZHViYWklMjBhcGFydG1lbnQlMjBtb2Rlcm4lMjByZWFsJTIwZXN0YXRlfGVufDB8fHx8MTc5MjY2OTg3Nnww&ixlib=rb-4.1.0&q=85",
    title: "Developers",
    sub: "Residential & commercial",
  },
  {
    img: "https://images.pexels.com/photos/33557042/pexels-photo-33557042.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Luxury Properties",
    sub: "Premium listings",
  },
  {
    img: "https://images.pexels.com/photos/34378029/pexels-photo-34378029.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Investment Firms",
    sub: "Global portfolios",
  },
];

export const TrustedBy = () => {
  return (
    <section data-testid="trusted-by-section" className="py-16 sm:py-24 bg-[#12203c] relative overflow-hidden">
      <div className="absolute inset-0 stars-bg opacity-30 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-4"
          >
            <p className="font-code text-xs sm:text-sm uppercase tracking-[0.25em] text-[#fba31b] font-bold">Trusted By</p>
            <h2 className="font-display mt-4 text-3xl sm:text-4xl font-bold tracking-tight">
              Real Estate Firms <span className="text-[#fba31b]">We Supercharge</span>
            </h2>
            <p className="mt-4 text-slate-300 text-base leading-relaxed">
              From boutique brokerages to growing developers, we help brands create property content that converts.
            </p>
          </motion.div>

          <div className="lg:col-span-8 grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
            {CLIENTS.map((c, i) => (
              <motion.div
                key={c.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.55, delay: i * 0.1 }}
                data-testid={`client-card-${c.title.toLowerCase().replace(/\s/g, "-")}`}
                className="group"
              >
                <div className="rounded-2xl overflow-hidden border border-white/10 aspect-[4/3]">
                  <img src={c.img} alt={c.title} className="img-duotone w-full h-full object-cover" />
                </div>
                <h3 className="mt-3 font-display text-base sm:text-lg font-bold">{c.title}</h3>
                <p className="text-xs sm:text-sm text-slate-400">{c.sub}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
